import {
  type AlertCategory,
  type BusinessUnit,
  type CommentFlagOption,
  type EmailAttachment,
  type EmailTemplate,
  type ExtraJSON,
  type IntegrationConfig,
  type IntegrationToken,
  type ObjectTypeWorkflowKindRelation,
  type ProcessKind,
  type ProcessPDFTemplate,
  type ProcessStatus,
  type ObjectStatus,
  type Region,
  type UserGroup
} from "@certa/queries/types/appSettings.types";
import { dbOps } from "../hooks/dbOps.store";
import { Intents } from "@certa/studio-core/src/constants/activityLogs.constants";
import type {
  BaseAppSettings,
  ReferencedAppSettings
} from "@certa/studio-core";

export const addAppSettingsUserGroup = (userGroup: UserGroup) => {
  dbOps().transaction(
    () => {
      dbOps().addUserGroup(userGroup);
    },
    {
      intent: Intents.UPDATE_APP_SETTINGS
    }
  );
};

export const updateUserGroup = (userGroup: UserGroup) => {
  dbOps().transaction(
    () => {
      dbOps().setUserGroup(userGroup);
    },
    {
      intent: Intents.UPDATE_FIELD
    }
  );
};

export const updateAppSettingsEmailTemplate = (
  emailTemplate: EmailTemplate
) => {
  dbOps().transaction(
    () => {
      dbOps().setEmailTemplate(emailTemplate);
    },
    {
      intent: Intents.UPDATE_FIELD
    }
  );
};

export const updateAppSettingsEmailAttachment = (
  emailAttachment: EmailAttachment
) => {
  dbOps().transaction(
    () => {
      dbOps().setEmailAttachment(emailAttachment);
    },
    {
      intent: Intents.UPDATE_FIELD
    }
  );
};

export const updateAppSettingsBusinessUnit = (businessUnit: BusinessUnit) => {
  dbOps().transaction(
    () => {
      dbOps().setBusinessUnit(businessUnit);
    },
    {
      intent: Intents.UPDATE_FIELD
    }
  );
};

export const updateAppSettingsRegion = (region: Region) => {
  dbOps().transaction(
    () => {
      dbOps().setRegion(region);
    },
    {
      intent: Intents.UPDATE_FIELD
    }
  );
};

export const updateAppSettingsExtraJSON = (extraJSON: ExtraJSON) => {
  dbOps().transaction(
    () => {
      dbOps().setExtraJSON(extraJSON);
    },
    {
      intent: Intents.UPDATE_FIELD
    }
  );
};

export const updateAppSettingsProcessKind = (processKind: ProcessKind) => {
  dbOps().transaction(
    () => {
      dbOps().setProcessKind(processKind);
    },
    {
      intent: Intents.UPDATE_FIELD
    }
  );
};

export const updateAppSettingsProcessStatus = (
  processStatus: ProcessStatus
) => {
  dbOps().transaction(
    () => {
      dbOps().setProcessStatus(processStatus);
    },
    {
      intent: Intents.UPDATE_FIELD
    }
  );
};

export const updateAppSettingsObjectStatus = (objectStatus: ObjectStatus) => {
  dbOps().transaction(
    () => {
      dbOps().setObjectStatus(objectStatus);
    },
    {
      intent: Intents.UPDATE_FIELD
    }
  );
};

export const updateAppSettingsProcessPDFTemplate = (
  processPDFTemplate: ProcessPDFTemplate
) => {
  dbOps().transaction(
    () => {
      dbOps().setProcessPDFTemplate(processPDFTemplate);
    },
    {
      intent: Intents.UPDATE_FIELD
    }
  );
};

export const updateAppSettingsAlertCategory = (
  alertCategory: AlertCategory
) => {
  dbOps().transaction(
    () => {
      dbOps().setAlertCategory(alertCategory);
    },
    {
      intent: Intents.UPDATE_FIELD
    }
  );
};

export const updateAppSettingsCommentFlagOption = (
  commentFlagOption: CommentFlagOption
) => {
  dbOps().transaction(
    () => {
      dbOps().setCommentFlagOption(commentFlagOption);
    },
    {
      intent: Intents.UPDATE_FIELD
    }
  );
};

export const addObjectTypeWFKindRelation = (
  relation: ObjectTypeWorkflowKindRelation
) => {
  dbOps().transaction(
    () => {
      dbOps().addObjectTypeWorkflowKindRelation(relation);
    },
    {
      intent: Intents.UPDATE_APP_SETTINGS
    }
  );
};

export const addAppSettingsProcessKind = (processKind: ProcessKind) => {
  dbOps().transaction(
    () => {
      dbOps().addProcessKind(processKind);
    },
    {
      intent: Intents.UPDATE_APP_SETTINGS
    }
  );
};

export const addAppSettingsProcessStatus = (processStatus: ProcessStatus) => {
  dbOps().transaction(
    () => {
      dbOps().addProcessStatus(processStatus);
    },
    {
      intent: Intents.UPDATE_APP_SETTINGS
    }
  );
};

export const addAppSettingsObjectStatus = (objectStatus: ObjectStatus) => {
  dbOps().transaction(
    () => {
      dbOps().addObjectStatus(objectStatus);
    },
    {
      intent: Intents.UPDATE_APP_SETTINGS
    }
  );
};

export const addAppSettingsEmailTemplate = (emailTemplate: EmailTemplate) => {
  dbOps().transaction(
    () => {
      dbOps().addEmailTemplate(emailTemplate);
    },
    {
      intent: Intents.UPDATE_APP_SETTINGS
    }
  );
};

export const addAppSettingsEmailAttachment = (
  emailAttachment: EmailAttachment
) => {
  dbOps().transaction(
    () => {
      dbOps().addEmailAttachment(emailAttachment);
    },
    {
      intent: Intents.UPDATE_APP_SETTINGS
    }
  );
};

export const addAppSettingsExtraJSON = (extraJSON: ExtraJSON) => {
  dbOps().transaction(
    () => {
      dbOps().addExtraJSON(extraJSON);
    },
    {
      intent: Intents.UPDATE_APP_SETTINGS
    }
  );
};

export const addAppSettingsBusinessUnit = (businessUnit: BusinessUnit) => {
  dbOps().transaction(
    () => {
      dbOps().addBusinessUnit(businessUnit);
    },
    {
      intent: Intents.UPDATE_APP_SETTINGS
    }
  );
};

export const addAppSettingsRegion = (region: Region) => {
  dbOps().transaction(
    () => {
      dbOps().addRegion(region);
    },
    {
      intent: Intents.UPDATE_APP_SETTINGS
    }
  );
};

export const addAppSettingsAlertCategory = (alertCategory: AlertCategory) => {
  dbOps().transaction(
    () => {
      dbOps().addAlertCategory(alertCategory);
    },
    {
      intent: Intents.UPDATE_APP_SETTINGS
    }
  );
};

export const addAppSettingsProcessPDFTemplate = (
  processPDFTemplate: ProcessPDFTemplate
) => {
  dbOps().transaction(
    () => {
      dbOps().addProcessPDFTemplate(processPDFTemplate);
    },
    {
      intent: Intents.UPDATE_APP_SETTINGS
    }
  );
};

export const addAppSettingsCommentFlagOption = (
  commentFlagOption: CommentFlagOption
) => {
  dbOps().transaction(
    () => {
      dbOps().addCommentFlagOption(commentFlagOption);
    },
    {
      intent: Intents.UPDATE_APP_SETTINGS
    }
  );
};

export const deleteUserGroup = (usergroupName: string) => {
  dbOps().transaction(
    () => {
      dbOps().deleteUserGroup(usergroupName);
    },
    {
      intent: Intents.UPDATE_APP_SETTINGS
    }
  );
};

export const deleteAppSettingsEmailTemplate = (slug: string) => {
  dbOps().transaction(
    () => {
      dbOps().deleteEmailTemplate(slug);
    },
    {
      intent: Intents.UPDATE_APP_SETTINGS
    }
  );
};

export const deleteAppSettingsEmailAttachment = (title: string) => {
  dbOps().transaction(
    () => {
      dbOps().deleteEmailAttachment(title);
    },
    {
      intent: Intents.UPDATE_APP_SETTINGS
    }
  );
};

export const deleteAppSettingsBusinessUnit = (code: string) => {
  dbOps().transaction(
    () => {
      dbOps().deleteBusinessUnit(code);
    },
    {
      intent: Intents.UPDATE_APP_SETTINGS
    }
  );
};

export const deleteAppSettingsRegion = (code: string) => {
  dbOps().transaction(
    () => {
      dbOps().deleteRegion(code);
    },
    {
      intent: Intents.UPDATE_APP_SETTINGS
    }
  );
};

export const deleteAppSettingsExtraJSON = (tag: string) => {
  dbOps().transaction(
    () => {
      dbOps().deleteExtraJSON(tag);
    },
    {
      intent: Intents.UPDATE_APP_SETTINGS
    }
  );
};

export const deleteAppSettingsProcessKind = (tag: string) => {
  dbOps().transaction(
    () => {
      dbOps().deleteProcessKind(tag);
    },
    {
      intent: Intents.UPDATE_APP_SETTINGS
    }
  );
};

export const deleteAppSettingsProcessStatus = (tag: string) => {
  dbOps().transaction(
    () => {
      dbOps().deleteProcessStatus(tag);
    },
    {
      intent: Intents.UPDATE_APP_SETTINGS
    }
  );
};

export const deleteAppSettingsObjectStatus = (tag: string) => {
  dbOps().transaction(
    () => {
      dbOps().deleteObjectStatus(tag);
    },
    {
      intent: Intents.UPDATE_APP_SETTINGS
    }
  );
};

export const deleteAppSettingsProcessPDFTemplate = (tag: string) => {
  dbOps().transaction(
    () => {
      dbOps().deleteProcessPDFTemplate(tag);
    },
    {
      intent: Intents.UPDATE_APP_SETTINGS
    }
  );
};

export const deleteAppSettingsAlertCategory = (tag: string) => {
  dbOps().transaction(
    () => {
      dbOps().deleteAlertCategory(tag);
    },
    {
      intent: Intents.UPDATE_APP_SETTINGS
    }
  );
};

export const deleteAppSettingsCommentFlagOption = (tag: string) => {
  dbOps().transaction(
    () => {
      dbOps().deleteCommentFlagOption(tag);
    },
    {
      intent: Intents.UPDATE_APP_SETTINGS
    }
  );
};

export const deleteObjectTypeWFKindRelation = (
  objectTypeWFKindRelation: ObjectTypeWorkflowKindRelation
) => {
  dbOps().transaction(
    () => {
      dbOps().deleteObjectTypeWorkflowKindRelation(objectTypeWFKindRelation);
    },
    {
      intent: Intents.UPDATE_APP_SETTINGS
    }
  );
};

export const replaceAppSettings = (appSettings: ReferencedAppSettings) => {
  dbOps().transaction(
    () => {
      dbOps().replaceAllAppSettings(appSettings);
    },
    {
      intent: Intents.UPDATE_APP_SETTINGS
    }
  );
};

export const addIntegrationToken = (integrationToken: IntegrationToken) => {
  dbOps().transaction(
    () => {
      dbOps().addIntegrationToken(integrationToken);
    },
    {
      intent: Intents.UPDATE_APP_SETTINGS
    }
  );
};

export const addIntegrationConfig = (integrationConfig: IntegrationConfig) => {
  dbOps().transaction(
    () => {
      dbOps().addIntegrationConfig(integrationConfig);
    },
    {
      intent: Intents.UPDATE_APP_SETTINGS
    }
  );
};

export const updateBaseAppSettings = (baseAppSettings: BaseAppSettings) => {
  dbOps().transaction(
    () => {
      dbOps().setBaseAppSettings(baseAppSettings);
    },
    {
      intent: Intents.UPDATE_APP_SETTINGS
    }
  );
};
